import React from "react";
import Navbar from "./global-components/navbar";
import Page_header from "./global-components/page-header";
import ServiceTwo from "./section-components/service-two";
import Property from "./property";
import PropertyByDubai from "./new-components/propertybydubai";
import PropertySell from "./new-components/property-sell";
import Footer from './global-components/footer';
import PropertyRent from "./new-components/propertyforRent";




const Services = () => {

    return (
        <div>
            <Navbar />
            <Page_header headertitle="Service Page" />
            <ServiceTwo />
            <PropertyByDubai />
            <PropertySell />
            <PropertyRent />
            <Footer />
        </div>
    )
}

export default Services